// Week 53 is the days between 52 and January 1.  There's a week 0 if January 1 doesn't fall on a Monday.  If it doesn't, then the days leading up to the first monday are week 0.
export default {
	2020: {
		lastWeek: {
			start: 1609135200,
			end: 1609480799,
		},
	},
	2021: {
		firstWeek: {
			start: 1609480800,
			end: 1609739999,
		},
		lastWeek: {
			start: 1640584800,
			end: 1641016799,
		},
	},
	2022: {
		firstWeek: {
			start: 1641016800,
			end: 1641189599,
		},
		lastWeek: {
			start: 1672034400,
			end: 1672552799,
		},
	},
	2023: {
		firstWeek: {
			start: 1672552800,
			end: 1672639199,
		},
		lastWeek: {
			// this week actuall works out
			start: 1703484000,
			end: 1704088799,
		},
	},
	2024: {
		firstWeek: {
			start: 1704088800,
			end: 1704693599,
		},
		lastWeek: {
			start: 1735538400,
			end: 1735711199,
		},
	},
	2025: {
		firstWeek: {
			start: 1735711200,
			end: 1736143199,
		},
		lastWeek: {
			start: 1766988000,
			end: 1767247199,
		},
	},
}